import { render, staticRenderFns } from "./MedicalReport.vue?vue&type=template&id=adefd674&scoped=true"
import script from "./MedicalReport.vue?vue&type=script&lang=js"
export * from "./MedicalReport.vue?vue&type=script&lang=js"
import style0 from "./MedicalReport.vue?vue&type=style&index=0&id=adefd674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adefd674",
  null
  
)

export default component.exports